import { useRef, useState } from "react";
import useStore from "./store";
import Home from "./pages/Home";
import { observer } from "mobx-react-lite";
// import zy from "./assets/img2/zy2.png";
// import bzq from "./assets/img2/bzq2.png";
// import cc from "./assets/img2/cc2.png";
// import wb from "./assets/img2/wb2.png";
import lj from "./assets/img2/lj2.png";

function App() {
  const [videoObj, setVideoObj] = useState({
    posterImg: lj,
    src: "https://vodpub1.v.news.cn/original/20221207/76ef496e9b4d403c9b1d3f0cd01cc764.mp4",
  });

  const { playStore } = useStore();

  const tempHandler = (posterImg, src, id) => {
    setVideoObj({
      posterImg: posterImg,
      src: src,
    });
    playStore.setPlay(id);
  };

  const pageView = useRef();

  const [myH, setMyH] = useState(460);

  const wheelHandler = () => {
    window.scrollTo(0, myH);
  };

  const getHeight = (value) => {
    setMyH(value);
  };

  return (
    <div className="App" ref={pageView}>
      <Home
        onTemp={tempHandler}
        videoObj={videoObj}
        onWheel={wheelHandler}
        onHeight={getHeight}
      />
    </div>
  );
}

export default observer(App);
